import { connect } from "react-redux";
import { getShowPlayers } from "../../reducers/ui/selectors";
import { togglePlayers } from "../../reducers/ui/actions";
import { getPlayerName, getPlayers } from "../../reducers/user/selectors";
import {
  addPlayer,
  removePlayer,
  setActivePlayer
} from "../../reducers/user/actions";

import Players from "./Players";

const mapStateToProps = state => ({
  show: getShowPlayers(state),
  players: getPlayers(state),
  activePlayer: getPlayerName(state)
});

const mapDispatchToProps = dispatch => ({
  hidePlayers: () => dispatch(togglePlayers(false)),
  addPlayer: playerName => dispatch(addPlayer(playerName)),
  setActivePlayer: playerName => dispatch(setActivePlayer(playerName)),
  removePlayer: playerName => dispatch(removePlayer(playerName))
});

export default connect(mapStateToProps, mapDispatchToProps)(Players);



// WEBPACK FOOTER //
// ./src/components/Players/PlayersContainer.js